import * as React from 'react';

import { DropdownMenu, IconButton } from '@hotjar/hotsauce';
import { useTranslation } from 'react-i18next';

import type { ExportFormat } from './types';

interface ExportOptionsProps {
  onExportList: (format: ExportFormat) => void;
}

export const ExportOptions = React.forwardRef<HTMLInputElement, ExportOptionsProps>(
  ({ onExportList }: ExportOptionsProps, ref): JSX.Element => {
    const { t } = useTranslation();

    return (
      <DropdownMenu
        ref={ref}
        trigger={
          <IconButton
            icon="download"
            description={t('common:recordings.list-actions.export-action.tooltip')}
            tooltipText={t('common:recordings.list-actions.export-action.tooltip')}
            size="s"
            kind="ghost"
            data-testid="recordings-list-actions-export"
          />
        }
      >
        <DropdownMenu.Item onClick={() => onExportList('csv')}>
          {t('common:recordings.list-actions.export-action.export-csv')}
        </DropdownMenu.Item>
        <DropdownMenu.Item onClick={() => onExportList('xlsx')}>
          {t('common:recordings.list-actions.export-action.export-excel')}
        </DropdownMenu.Item>
      </DropdownMenu>
    );
  },
);
